import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { orgmgrGql, ResultOf } from '@nemlia/hasura-gql';
import { uuid } from '@nemlia/hasura-schema';
const STYRA_GET_USER_PERMISSIONS = orgmgrGql(/* GraphQL */`
  query STYRA_GET_USER_PERMISSIONS($userId: uuid!) {
    view_user_permissions(
      where: { user_id: { _eq: $userId } }
      distinct_on: [organisation_id, type]
      order_by: [{ organisation_id: asc }, { type: asc }]
    ) {
      organisation_id
      type
    }
  }
`);
export type UserPermissionList = ResultOf<typeof STYRA_GET_USER_PERMISSIONS>['view_user_permissions'];
export const useGetUserPermissions = userId => {
  const $ = _c(5);
  let t0;
  if ($[0] !== userId) {
    t0 = {
      userId
    };
    $[0] = userId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = !userId;
  let t2;
  if ($[2] !== t0 || $[3] !== t1) {
    t2 = {
      variables: t0,
      skip: t1
    };
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return useQuery(STYRA_GET_USER_PERMISSIONS, t2);
};